import React, { useState, useEffect } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "./AgentTransfers.scss";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";

const fakeData = [
  {
    recipient: "Carol",
    amount: "$1000",
    status: "Pending",
    date: "3/15/2024",
    type: "Inbound",
  },
  {
    recipient: "Alex",
    amount: "$500",
    status: "Completed",
    date: "3/16/2024",
    type: "Outbound",
  },
  {
    recipient: "Sam",
    amount: "$1200",
    status: "Failed",
    date: "3/17/2024",
    type: "Inbound",
  },
  {
    recipient: "Jamie",
    amount: "$750",
    status: "Pending",
    date: "3/18/2024",
    type: "Outbound",
  },
  {
    recipient: "Taylor",
    amount: "$300",
    status: "Completed",
    date: "3/19/2024",
    type: "Inbound",
  },
  {
    recipient: "Casey",
    amount: "$950",
    status: "Pending",
    date: "3/20/2024",
    type: "Outbound",
  },
  {
    recipient: "Jordan",
    amount: "$400",
    status: "Failed",
    date: "3/21/2024",
    type: "Inbound",
  },
  {
    recipient: "Morgan",
    amount: "$1100",
    status: "Completed",
    date: "3/22/2024",
    type: "Outbound",
  },
  {
    recipient: "Chris",
    amount: "$650",
    status: "Pending",
    date: "3/23/2024",
    type: "Inbound",
  },
  {
    recipient: "Pat",
    amount: "$800",
    status: "Failed",
    date: "3/24/2024",
    type: "Outbound",
  },
  {
    recipient: "Drew",
    amount: "$550",
    status: "Completed",
    date: "3/25/2024",
    type: "Inbound",
  },
  {
    recipient: "Lee",
    amount: "$900",
    status: "Pending",
    date: "3/26/2024",
    type: "Outbound",
  },
  {
    recipient: "Quinn",
    amount: "$350",
    status: "Failed",
    date: "3/27/2024",
    type: "Inbound",
  },
  {
    recipient: "Reese",
    amount: "$1050",
    status: "Completed",
    date: "3/28/2024",
    type: "Outbound",
  },
  {
    recipient: "Sky",
    amount: "$200",
    status: "Pending",
    date: "3/29/2024",
    type: "Inbound",
  },
  {
    recipient: "Alexis",
    amount: "$100",
    status: "Failed",
    date: "3/30/2024",
    type: "Outbound",
  },
  {
    recipient: "Blake",
    amount: "$1150",
    status: "Completed",
    date: "3/31/2024",
    type: "Inbound",
  },
  {
    recipient: "Cameron",
    amount: "$700",
    status: "Pending",
    date: "4/1/2024",
    type: "Outbound",
  },
  {
    recipient: "Dana",
    amount: "$850",
    status: "Failed",
    date: "4/2/2024",
    type: "Inbound",
  },
  {
    recipient: "Elliot",
    amount: "$600",
    status: "Completed",
    date: "4/3/2024",
    type: "Outbound",
  },
];

export default function AgentTransfers({ tableData }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [sorting, setSorting] = useState({
    column: "",
    direction: "asc",
  });
  const [selectedData, setSelectedData] = useState([]);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const handleClose = () => setOpen(false);

  const handleSort = (columnName) => {
    const isAsc = sorting.column === columnName && sorting.direction === "asc";
    setSorting({
      column: columnName,
      direction: isAsc ? "desc" : "asc",
    });
  };

  const sortedData = [...fakeData].sort((a, b) => {
    if (!sorting.column) return 0;

    let aValue = a[sorting.column];
    let bValue = b[sorting.column];

    if (sorting.column === "amount" || sorting.column === "amountDue") {
      aValue = Number(aValue.replace(/[^0-9.-]+/g, ""));
      bValue = Number(bValue.replace(/[^0-9.-]+/g, ""));
    }

    if (sorting.column === "date") {
      aValue = new Date(aValue);
      bValue = new Date(bValue);
    }

    const isAsc = sorting.direction === "asc";
    if (aValue < bValue) {
      return isAsc ? -1 : 1;
    }
    if (aValue > bValue) {
      return isAsc ? 1 : -1;
    }
    return 0;
  });

  const pageCount = fakeData ? Math.ceil(fakeData.length / rowsPerPage) : 0;
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleOpen = (subAccounts) => {
    setOpen(true);
    setSelectedData([subAccounts]);
  };

  useEffect(() => {
    return () => {
      setSorting({
        column: "",
        direction: "asc",
      });
    };
  }, []);

  const sortedAndFilteredData = sortedData.filter((row) => {
    return (
      (selectedStatus ? row.status === selectedStatus : true) &&
      (selectedType ? row.type === selectedType : true) &&
      row.recipient.toLowerCase().includes(search.toLowerCase())
    );
  });

  return (
    <div className="agenttransfers-table">
      <div className="filter-container">
        <div className="select-container">
          <div>
            <div>
              <label for="time" className="selector-titles">
                Loan Type
              </label>
            </div>
            <div className="transaction-selector">
              <select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
                className="status-dropdown"
              >
                <option value=""> All Statuses</option>
                <option value="Pending">Pending</option>
                <option value="Completed">Completed</option>
                <option value="Failed">Failed</option>
              </select>
            </div>
          </div>
          <div>
            <div>
              <label for="time" className="selector-titles">
                Types
              </label>
            </div>
            <div className="transaction-selector">
              <select
                value={selectedType}
                onChange={(e) => setSelectedType(e.target.value)}
                className="type-dropdown"
              >
                <option value="">All Types</option>
                <option value="Inbound">Inbound</option>
                <option value="Outbound">Outbound</option>
              </select>
            </div>
          </div>
        </div>
        <input
          type="text"
          placeholder="Search by recipient name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
      </div>
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("date")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Date</p>
                  {sorting.column === "date" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("status")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Status</p>
                  {sorting.column === "status" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("recipient")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Recipient</p>
                  {sorting.column === "recipient" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("type")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Type</p>
                  {sorting.column === "type" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>

              <TableCell
                align="left"
                className="transaction-table-headers"
                onClick={() => handleSort("amount")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Amount</p>
                  {sorting.column === "amount" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedAndFilteredData
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <React.Fragment key={index}>
                  <TableRow>
                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date">{row.date}</p>
                    </TableCell>
                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date">{row.status}</p>
                    </TableCell>

                    <TableCell style={{ width: 300 }} align="left">
                      <div className="transaction-table-address-container">
                        <p className="transaction-table-date ">
                          {row.recipient}
                        </p>
                      </div>
                    </TableCell>

                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date">{row.type}</p>
                    </TableCell>
                    <TableCell style={{ width: 200 }} align="left">
                      <p className="transaction-table-date">{row.amount}</p>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
        <BaseCustomerTable
          page={page}
          onPageChange={handleChangePage}
          pageNumbers={pageNumbers}
        />
      </TableContainer>
    </div>
  );
}
